export const FETCH_PROJECTS = 'fetch_projects'
export const FETCH_CERTIFICATES = 'fetch_certificates'
export const FETCH_PROJECT_BY_ID = 'FETCH_PROJECT_BY_ID'
export const AUTHENTICATE_ADMIN = 'AUTHENTICATE_ADMIN'
export const ADD_PROJECT = 'ADD_PROJECT'
